// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2z-_K","resendInfoText":"OnGoingPaymentBox_resendInfoText__3CpP-"};